import { render } from "./MessengerPrivacySettingsInline.vue?vue&type=template&id=8a1bfcec&scoped=true&ts=true"
import script from "./MessengerPrivacySettingsInline.vue?vue&type=script&lang=ts"
export * from "./MessengerPrivacySettingsInline.vue?vue&type=script&lang=ts"

import "./MessengerPrivacySettingsInline.vue?vue&type=style&index=0&id=8a1bfcec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a1bfcec"]])

export default __exports__